import React from 'react';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import SettingsDescription from '@dashboard/components/SettingsDescription';

import GeneralSettingsForm from './components/GeneralSettingsForm';

const SettingsGeneral = () => {
  return (
    <SettingsContainer>
      <SettingsHeader id="general">General</SettingsHeader>

      <SettingsDescription className="mb-4">
        Add your branding and contact details, and set your default currency and homepage.
      </SettingsDescription>

      <GeneralSettingsForm />
    </SettingsContainer>
  );
};

export default SettingsGeneral;
